import { formatMoney } from '../utilities';

const PriceDisplay = {
  addUnavailable: function (element, isMainProduct) {
    if (!element) return;

    const soldOutEl = element.querySelector('.sold-out');

    if (!soldOutEl) {
      const tagToCreate = isMainProduct ? 'h2' : 'p';

      const newElement = document.createElement(tagToCreate);
      newElement.classList.add('sold-out');
      newElement.innerHTML = 'Indisponível';

      //No produto principal, exibe apenas o preço principal e o texto "Indisponível"
      //No product block e compra rápida, exibe apenas o texto "Indisponível"
      if (!isMainProduct) {
        element.innerHTML = '';
      }

      element.appendChild(newElement);
    }
  },

  addPercentage: function (element, variant) {
    if (!variant.on_sale) return;

    const newElement = document.createElement('p');
    newElement.classList.add('percentage');
    newElement.innerHTML = `${Math.round(100 - (variant.sale_price / variant.price) * 100)}% OFF`;

    element.appendChild(newElement);
  },

  addPrice: function (element, variant, HTMLtag) {
    const newElement = document.createElement(HTMLtag);
    newElement.classList.add('price-container-main');

    if (!variant.available) {
      newElement.classList.add('sold-out-price');
      newElement.innerHTML = `<span>Indisponível</span>`;
    } else {
      newElement.innerHTML = variant.on_sale
        ? `<div class="price-old-row">
            <del>${formatMoney(variant.price)}</del>
            <span class="percentage-tag">-${Math.round(100 - (variant.sale_price / variant.price) * 100)}%</span>
        </div>
        <ins class="current-price">${formatMoney(variant.sale_price)}</ins>`
        : `<ins class="current-price">${formatMoney(variant.price)}</ins>`;
    }

    element.appendChild(newElement);
  },

  addInstallments: function (element, variant, showWithInterest = true, showWithoutInterest = true) {
    if (!variant.installments || !variant.installments.length) return;

    const installmentOptions = variant.installments;
    const maxInstallment = installmentOptions[installmentOptions.length - 1];
    const isMobile = window.innerWidth <= 768;
    const labelJuros = maxInstallment.interest ? 'com juros no cartão' : isMobile ? 'sem juros' : 'Sem juros no cartão';

    const newElement = document.createElement('div');
    newElement.className = 'installments-card-bosch';
    newElement.innerHTML = `
        <p>ou ${formatMoney(variant.sale_price)} (${installmentOptions.length}x de ${formatMoney(maxInstallment.price)})</p>
        <p>${labelJuros}</p>
    `;

    element.appendChild(newElement);
  },

  addPIX: function (element, variant, type) {
    if (!pixDiscount) return;

    const newElement = document.createElement('div');
    newElement.className = 'pix-payment-block';

    const isFloating = element.closest('.floating-buy');

    if (newElement) {
      if (window.mobile && isFloating) {
        const finalPrice = variant.sale_price * (1 - pixDiscount / 100);
        newElement.innerHTML = `<svg class="icon"><use xlink:href="#icon-pix"/></svg> <b>${formatMoney(finalPrice)}</b> no PIX`;
      } else {
        newElement.innerHTML = `<svg class="icon"><use xlink:href="#icon-pix"/></svg>  À VISTA NO PIX / BOLETO`;
      }
    }

    element.appendChild(newElement);
  },

  addCashback: function (element, variant, type) {
    if (!variant.cashback || !variant.cashback.percentage || variant.cashback.percentage == 0) return;

    const newElement = document.createElement('p');
    newElement.classList.add('cashback');
    newElement.innerHTML =
      type == 'block'
        ? `${formatMoney((variant.sale_price / 100) * variant.cashback.percentage)} de cashback!`
        : `Ganhe até ${formatMoney((variant.sale_price / 100) * variant.cashback.percentage)} de cashback!`;

    element.appendChild(newElement);
  },

  addPreSale: function (price, type) {
    const priceEl = price.querySelector('.price');
    const product = price.closest('[data-product-box]');
    const element = product.querySelector('[data-pre-sale]');
    let text = 'Preço de pré-venda';

    if (!element) return;

    if (element.hasAttribute('data-pre-sale-text')) text = element.getAttribute('data-pre-sale-text');

    const hasPreSale = product.classList.contains('-pre-sale');

    if (type == 'main' && hasPreSale) {
      const flag = document.createElement('div');
      flag.classList.add('flag-pre-sale');
      flag.innerHTML = `<svg class="icon"><use xlink:href="#icon-timer"/></svg> ${text}`;

      priceEl.append(flag);

      const button = product.querySelector('.add-to-cart-button');
      const buttonText = button ? button.getAttribute('data-text-pre-sale') : false;

      if (button) button.innerHTML = buttonText; // Botão comprar com texto pré venda
    } else {
      type != 'main' && element.classList.remove('-hidden');
    }
  },

  productMain: function (element, variant) {
    const showWithInterest = true;
    const showWithoutInterest = true;

    element.innerHTML = '';

    if (!variant.available) {
      PriceDisplay.addPrice(element, variant, 'div');
      return;
    }

    // PriceDisplay.addPercentage(element, variant);
    PriceDisplay.addPrice(element, variant, 'div');
    PriceDisplay.addPIX(element, variant, 'block');
    PriceDisplay.addInstallments(element, variant, showWithInterest, showWithoutInterest);
    PriceDisplay.addCashback(element, variant, 'main');
    PriceDisplay.addPreSale(element, 'main');
  },

  productBlock: function (element, variant) {
    const showWithInterest = true;
    const showWithoutInterest = true;

    element.innerHTML = '';

    if (!variant.available) {
      PriceDisplay.addPrice(element, variant, 'div');
      return;
    }

    PriceDisplay.addPrice(element, variant, 'div');
    PriceDisplay.addPIX(element, variant, 'block');
    PriceDisplay.addInstallments(element, variant, showWithInterest, showWithoutInterest);
  },
};

export default PriceDisplay;
